import { Component, computed, effect, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService, NotificationService } from '../../services'
import { checkoutsColumns, printInventoryExportsColumns } from '../../utils/definitions.util'
import { SchemaUtil } from '../../utils'
import { TranslateService } from '@ngx-translate/core'
import { injectInfiniteQuery } from '@tanstack/angular-query-experimental'
import { InventoryExportService } from '../../services/entity-services/inventoryExport.service'

const DEFAULT_FILTERS = {
  // sortProp: 'created',
  // sortDir: 'desc',
}

@Component({
  selector: 'app-print-inventory-exports',
  templateUrl: 'print-inventory-exports.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PrintInventoryExportsComponent extends BaseListing implements OnInit {
  private inventoryExportService = inject(InventoryExportService)
  listingColumns = signal(printInventoryExportsColumns)
  reports: any[] = []
  totalItems = computed(() => {
    console.error(this.queryInventoryExports.data())
    return 100
  })
  // filters = { ...DEFAULT_FILTERS }
  loading = true
  // storageKey: WritableSignal<{ type: string; key: string }> = signal({ type: '', key: '' })
  sortProp = signal('created')
  sortDir = signal('desc')

  readonly queryInventoryExports = injectInfiniteQuery(() => ({
    queryKey: ['inventoryExports', { sortProp: this.sortProp(), sortDir: this.sortDir() }], // todo add  queryKey -> sort, filters, schema - columns
    queryFn: async ({ pageParam }) => {
      // const requestId = ++this.currentRequestId // unique ID per call
      // todo. disable for now - querySelectorAll gets all inputs from pages, even when they should be destroyed. (looking at you, Products form fields!)
      return await this.inventoryExportService
        .getInventoryExports(
          {
            page: pageParam,
            sort: this.sortProp(),
            direction: this.sortDir(),
          },
          SchemaUtil.inventoryExport
        )
        .then(result => {
          // todo this.saveViewSettings('printInventoryExports', this.filters)
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))

  constructor(
    protected core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) {
    super(core)
    effect(() => {
      this.queryInventoryExports.data()
    })
    // this.getStorageKey()
  }

  ngOnInit() {
    // this.filters = this.loadViewSettings('printInventoryExports') || { ...DEFAULT_FILTERS }
    this.loadSorting('printInventoryExports')
  }

  clearFilters(): void {
    this.queryInventoryExports.refetch()
    // todo effect ?
  }

  async createExportInventory(inventoryExport) {
    this.loading = true
    try {
      this.startRefreshing('queryInventoryExports')
      await this.core.services.inventoryExport.create(inventoryExport, { id: null }).then(() => {
        this.notificationService.success(this.translateService.instant('alert.inventory.created'))
      })
      // await this.filter(1) todo nemusim delat pak
      await this.queryInventoryExports.refetch()
    } catch (err) {
      console.error(err)
    } finally {
      // this.reloading = false
      this.loading = false
    }
  }
}
